import { createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "message-hover-wrapper",
    onMouseenter: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMouseEnter && _ctx.onMouseEnter(...args))),
    onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeave && _ctx.onMouseLeave(...args))),
    onTouchstartPassive: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onTouchStart && _ctx.onTouchStart(...args))),
    onTouchend: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onTouchEnd && _ctx.onTouchEnd(...args))),
    onTouchmove: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onTouchCancel && _ctx.onTouchCancel(...args)))
  }, [
    _createCommentVNode(" message content "),
    _renderSlot(_ctx.$slots, "message"),
    _createCommentVNode(" hover actions "),
    _createElementVNode("div", {
      class: _normalizeClass(["hover-actions-wrapper", [`pos-${_ctx.position}`, { visible: _ctx.isVisible }]]),
      ref: "wrapper",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["stop"]))
    }, [
      _renderSlot(_ctx.$slots, "actions")
    ], 2 /* CLASS */)
  ], 32 /* HYDRATE_EVENTS */))
}